import * as React from 'react';
import { Link, NavLink } from 'react-router-dom';
//icons
import icon2 from '../../img/icon2.png';

export default function HomePage()
{
    return (
        <div className="header__form2">
            <Link to="/" className="header__logo-1">
                <img src={icon2} alt="" />
            </Link>
            <p className="p-text">
                Olá, seja muito bem-vindo ao programa Momenta Mais. Selecione abaixo a ação que deseja.
            </p>
            <div className="header__form2-btns">
                <NavLink to="/store-search" className="btn-primary">
                    Farmácias participantes
                </NavLink>
                <NavLink to="/coupon-register" className="btn-primary">
                    Valide aqui o seu cupom
                </NavLink>
            </div>
        </div>
    )
}